import React from 'react'

import { useGetViewerQuery } from '@/generated/graphql'
import { ga, traceEvent } from '@/utils/ga'

import { UserInfoEditModal } from './user-info-edit-modal/user-info-edit-modal.component'
import { UserInfo } from './user-info.component'
import s from './user-info.module.less'

export const UserInfoContainer: React.FC<{
  userId: number
  hasLeftBar?: boolean
}> = ({ userId, hasLeftBar = false }) => {
  const { data } = useGetViewerQuery()
  const viewerId = data?.viewer.userId || 0
  const readonly = viewerId !== userId

  React.useEffect(() => {
    if (data) {
      const category = traceEvent.profile
      ga('event', category.events.show_page_profile, {
        event_category: category.event_category,
        event_label: data.viewer.userId === userId ? '1' : '0',
      })
    }
  }, [data])

  return (
    <div className={s.container}>
      <UserInfo userId={userId} readonly={readonly} viewerId={viewerId} hasLeftBar={hasLeftBar} />
      <UserInfoEditModal userId={userId} readonly={readonly} viewerId={viewerId} />
    </div>
  )
}
